<template>
  <div>
    <vx-card class="mb-8">
      <div class="search-container mb-6 px-0">
        <div
          class="flex flex-col md:flex-row w-full justify-between items-center no-margin gap-4"
        >
          <div
            class="flex-grow flex flex-col md:flex-row items-center w-full md:w-auto gap-4"
          >
            <div class="vx-col w-full md:w-auto md:min-w-300 md:mr-4 pl-0">
              <vs-input
                v-model="searchText"
                placeholder="Search..."
                class="w-full search-field"
                icon-pack="feather"
                icon="icon-search"
                icon-no-border
              />
            </div>

            <div class="vx-col w-full md:w-auto md:mr-4">
              <date-picker
                placeholder="Select date"
                v-model="selectedDate"
                type="date"
                format="DD/MM/YYYY"
                :disabled-date="notAfterToday"
                class="date-picker-field w-full"
              />
            </div>

            <div class="vx-col w-full md:w-auto">
              <div class="flex items-center justify-center md:justify-start">
                <vs-button
                  color="success"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-search"
                  @click.prevent="search"
                  class="mr-2"
                />
                <vs-button
                  color="#67767f"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-refresh-cw"
                  @click.prevent="refreshData"
                />
              </div>
            </div>
          </div>

          <div class="vx-col download-button self-end md:self-center">
            <vs-tooltip text="Download Excel Report">
              <div
                class="box toggle-chart"
                @click="showPopupSelectDateReport = true"
              >
                <font-awesome-icon
                  icon="fa-solid fa-file-lines"
                  class="large-faicon"
                />
              </div>
            </vs-tooltip>
          </div>
        </div>
      </div>

      <vs-prompt
        title="Export Excel"
        @cancel="cancelExport"
        @accept="downloadExcel"
        @close="cancelExport"
        :active.sync="showPopupSelectDateReport"
      >
        <p>Download audit log report (xlsx)</p>
        <div class="vx-row pt-4">
          <div class="vx-col sm:w-1/2 w-full mb-3">
            <datepickers
              placeholder="Start Date"
              :disabledDates="disabledDates"
              v-model="datestart"
            />
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-3">
            <datepickers
              placeholder="End Date"
              :disabledDates="disabledDates"
              v-model="dateend"
            />
          </div>
        </div>
      </vs-prompt>
      <vs-table stripe :data="tableData">
        <template slot="thead">
          <vs-th @click="toggleSort('id')" class="text-left cursor-pointer table-header-style">
            <div class="flex items-center">
              <span>No</span>
            </div>
          </vs-th>
          <vs-th @click="toggleSort('dateTime')" class="text-left cursor-pointer table-header-style">
            <div class="flex items-center">
              <span>Date & Time</span>
              <div
                class="ml-4 flex flex-col sort-icon-group"
                @click.stop="toggleSort('dateTime')"
                style="cursor: pointer"
              >
                <font-awesome-icon
                  :icon="['fas', 'caret-up']"
                  :class="getSortClass('dateTime', 'asc')"
                />
                <font-awesome-icon
                  :icon="['fas', 'caret-down']"
                  :class="getSortClass('dateTime', 'desc')"
                />
              </div>
            </div>
          </vs-th>
          <vs-th @click="toggleSort('userName')" class="text-left cursor-pointer table-header-style">
            <div class="flex items-center">
              <span>Username</span>
              <div
                class="ml-4 flex flex-col sort-icon-group"
                @click.stop="toggleSort('userName')"
                style="cursor: pointer"
              >
                <font-awesome-icon
                  :icon="['fas', 'caret-up']"
                  :class="getSortClass('userName', 'asc')"
                />
                <font-awesome-icon
                  :icon="['fas', 'caret-down']"
                  :class="getSortClass('userName', 'desc')"
                />
              </div>
            </div>
          </vs-th>
          <vs-th @click="toggleSort('role')" class="text-left cursor-pointer table-header-style">
            <div class="flex items-center">
              <span>Role</span>
              <div
                class="ml-4 flex flex-col sort-icon-group"
                @click.stop="toggleSort('role')"
                style="cursor: pointer"
              >
                <font-awesome-icon
                  :icon="['fas', 'caret-up']"
                  :class="getSortClass('role', 'asc')"
                />
                <font-awesome-icon
                  :icon="['fas', 'caret-down']"
                  :class="getSortClass('role', 'desc')"
                />
              </div>
            </div>
          </vs-th>
          <vs-th @click="toggleSort('position')" class="text-left cursor-pointer table-header-style">
            <div class="flex items-center">
              <span>Position</span>
              <div
                class="ml-4 flex flex-col sort-icon-group"
                @click.stop="toggleSort('position')"
                style="cursor: pointer"
              >
                <font-awesome-icon
                  :icon="['fas', 'caret-up']"
                  :class="getSortClass('position', 'asc')"
                />
                <font-awesome-icon
                  :icon="['fas', 'caret-down']"
                  :class="getSortClass('position', 'desc')"
                />
              </div>
            </div>
          </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr class="pln-color" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="indextr">
              {{ (currentPage - 1) * itemsPerPage + indextr + 1 }}
            </vs-td>

            <vs-td class="text-left" :data="tr.dateTime">
              {{ tr.dateTime }}
            </vs-td>

            <vs-td class="text-left" :data="tr.userName">
              {{ tr.userName }}
            </vs-td>

            <vs-td class="text-left" :data="tr.role">
              {{ tr.role }}
            </vs-td>

            <vs-td class="text-left" :data="tr.position">
              {{ tr.position }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="pagination-container">
        <div class="pagination-left">
          <span class="mr-2">show data</span>
          <vs-select
            style="width: 25%"
            v-model="itemsPerPage"
            @input="updateItemsPerPage"
          >
            <vs-select-item
              v-for="(option, index) in pageOptions"
              :key="index"
              :value="option.value"
              :text="option.text"
            />
          </vs-select>
        </div>
        <div class="pagination-right">
          <CustomPagination
            :current-page.sync="currentPage"
            :total-pages="totalPages"
            :total-data="totalData"
            @update:currentPage="getLogAuditLists"
          />
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import CustomPagination from "@/components/CustomPagination.vue";
import api from "@/api";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCaretUp, faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Datepickers from "vuejs-datepicker";
import moment from "moment";

library.add(faCaretUp, faCaretDown);

export default {
  components: {
    DatePicker,
    CustomPagination,
    Datepickers,
    "font-awesome-icon": FontAwesomeIcon,
  },
  data() {
    return {
      searchText: "",
      selectedDate: null,
      currentPage: 1,
      itemsPerPage: 10,
      pageOptions: [
        { value: 10, text: '10' },
        { value: 25, text: '25' },
        { value: 50, text: '50' },
        { value: 100, text: '100' }
      ],
      tableData: [],
      totalData: 0,
      sortField: "",
      sortOrder: "asc",
      showPopupSelectDateReport: false,
      datestart: null,
      dateend: null,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalData / this.itemsPerPage);
    },
    disabledDates() {
      const todayEnd = new Date();
      todayEnd.setHours(23, 59, 0, 0);
      return {
        from: todayEnd,
      };
    },
  },
  mounted() {
    this.getLogAuditLists();
  },
  methods: {
    //Update item pages (handling for change limit of page)
    updateItemsPerPage() {
      this.currentPage = 1;
      this.getLogAuditLists();
    },
    notAfterToday(date) {
      return date > new Date(new Date().setHours(23, 59, 0, 0));
    },
    search() {
      this.currentPage = 1;
      this.getLogAuditLists();
    },
    refreshData() {
      // reset all filter
      // this.searchText = "";
      // this.selectedDate = null;
      // this.currentPage = 1;
      // this.sortField = "";
      // this.sortOrder = "asc";
      this.getLogAuditLists();
    },
    getLogAuditLists() {
      this.$vs.loading();
      const params = {
        page: this.currentPage,
        limit: this.itemsPerPage,
      };

      if (this.searchText) {
        params.search = this.searchText;
      }

      if (this.selectedDate) {
        const date = new Date(this.selectedDate);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        params.date = `${year}-${month}-${day}`;
      }

      if (this.sortField) {
        params.sort = `${this.sortField} ${this.sortOrder}`;
      }

      console.log("📦 [getLogAuditLists] API Params:", params);

      api
        .getLogAudit(params)
        .then((result) => result.data)
        .then((data) => {
          console.log("✅ [getLogAuditLists] Response:", data);
          if (data.status) {
            this.tableData = data.data;
            this.totalData = data.totalData;
          }
          this.$vs.loading.close();
        })
        .catch((e) => {
          console.error("❌ [getLogAuditLists] Error:", e);
          this.$vs.loading.close();
        });
    },
    toggleSort(field) {
      console.log("🔽 [toggleSort] Clicked field:", field);

      if (this.sortField === field) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }

      console.log("🔄 [toggleSort] New sortField:", this.sortField);
      console.log("🔄 [toggleSort] New sortOrder:", this.sortOrder);

      this.getLogAuditLists();
    },
    getSortClass(field, direction) {
      const isActive = this.sortField === field && this.sortOrder === direction;
      return {
        "sort-icon": true,
        active: isActive,
      };
    },
    convertToCSV(objArray) {
      var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
      var str = "";

      for (var i = 0; i < array.length; i++) {
        var line = "";
        for (var index in array[i]) {
          if (line != "") line += ",";

          line += array[i][index];
        }

        str += line + "\r\n";
      }

      return str;
    },
    exportCSVFile(headers, items, fileTitle) {
      if (headers) {
        items.unshift(headers);
      }

      // Convert Object to JSON
      var csv = this.convertToCSV(items);

      var exportedFilename = fileTitle + ".csv" || "export.csv";

      var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, exportedFilename);
      } else {
        var link = document.createElement("a");
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", exportedFilename);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    downloadExcel() {
      if (!this.datestart || !this.dateend) {
        this.$vs.notify({
          title: "Error",
          text: "Please select start and end date",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      if (this.dateend < this.datestart) {
        this.$vs.notify({
          title: "Error",
          text: "End date must be after start date",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      this.$vs.loading();

      const params = {
        startdate: moment(this.datestart).format("YYYY-MM-DD"),
        enddate: moment(this.dateend).format("YYYY-MM-DD"),
      };

      if (this.searchText) {
        params.search = this.searchText;
      }

      console.log("📥 [downloadExcel] API Params:", params);

      api
        .getLogAuditExcel(params)
        .then((result) => result.data)
        .then((data) => {

          if (data.status && data.data.length > 0) {
            const headers = {
              dateTime: "Date & Time",
              userName: "Username",
              role: "Role",
              position: "Position",
            };

            const itemsFormatted = data.data.map((item) => {
              return {
                dateTime: item.dateTime || "",
                userName: item.userName || "",
                role: item.role || "",
                position: item.position || "",
              };
            });

            this.datestart = null;
            this.dateend = null;

            const now = Date.now();
            var fileTitle = "log-audit-" + now;

            this.$vs.loading.close();
            this.exportCSVFile(headers, itemsFormatted, fileTitle);

            this.$vs.notify({
              title: "Success",
              text: "Audit log report downloaded successfully",
              color: "success",
              position: "top-right",
            });
          } else {
            this.$vs.notify({
              title: "Peringatan",
              text: "Tidak ada data pada tanggal tersebut",
              color: "warning",
              position: "top-right",
            });
          }

          this.showPopupSelectDateReport = false;
          this.$vs.loading.close();
        })
        .catch((error) => {
          console.error("❌ [downloadExcel] Error:", error);
          this.$vs.notify({
            title: "Failed",
            text: "Failed to download audit log report",
            color: "danger",
            position: "top-right",
          });
          this.$vs.loading.close();
        });
    },
    cancelExport() {
      this.showPopupSelectDateReport = false;
      this.datestart = null;
      this.dateend = null;
    },
  },
};
</script>

<style scoped>
.search-container {
  width: 100%;
}

.no-margin {
  margin: 0;
}

.search-field {
  width: 100%;
}

.date-picker-field {
  width: 100%;
}

@media (min-width: 768px) {
  .search-field {
    min-width: 300px;
  }

  .date-picker-field {
    min-width: 220px;
  }
}

.download-button {
  padding-right: 1rem;
}

.large-faicon {
  font-size: 42px;
  color: #1372ac;
  margin-right: 0;
}

.box.toggle-chart {
  cursor: pointer;
}

/* Style adjustments for the table */
.vs-table {
  margin-top: 1rem;
  width: 100%;
  border: 1px solid #eee;
  border-radius: 8px;
}

.table-header-style {
  font-weight: 600;
  color: #444;
  padding: 1rem;
}

.vs-table--thead {
  background-color: #f8f8f8;
}

.vs-table--tbody > .vs-table--tr {
  border-bottom: 1px solid #eee;
}

.vs-table--td {
  padding: 0.75rem 1rem;
}

.sort-icon-group {
  line-height: 0.7;
}

.sort-icon {
  color: white;
  font-size: 12px;
  transition: opacity 0.2s ease;
}

.sort-icon.active {
  opacity: 1;
  color: #009fb2;
}

.cursor-pointer {
  cursor: pointer;
}
.pagination-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  gap: 1rem;
  width: 100%;
}
@media (min-width: 768px) {
  .pagination-container {
    flex-direction: row;
    gap: 0;
  }
}
.pagination-left {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
@media (min-width: 768px) {
  .pagination-left {
    justify-content: flex-start;
    width: auto;
  }
}
.pagination-right {
  width: 100%;
  display: flex;
  justify-content: center;
  overflow-x: auto;
}
@media (min-width: 768px) {
  .pagination-right {
    width: auto;
    justify-content: flex-end;
  }
}
</style>
